import { FETCH_COUNTRIES_LIST } from "../../actions/actionTypes";

const initialState = {  
    data: [],
    loading: false,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {    
        case FETCH_COUNTRIES_LIST.REQUEST:
            return { ...state, loading: true };
        case FETCH_COUNTRIES_LIST.FAILURE:
            return { ...state, loading: false };
        case FETCH_COUNTRIES_LIST.SUCCESS:
            return { ...state, data: action.data, loading: false };
        default:
            return state;
    }
};

export default reducer;